import * as React from 'react';

import Link from 'components/atoms/Link';
import i18n from 'helper/i18n';

type ProgramQuitProps = {
	hours: number;
	todos: number;
	loading: boolean;
	doRequestFinishManually: Function;
};

const labelBase = 'react.impulsCoach.components.programQuit';

export default class ProgramQuit extends React.Component<ProgramQuitProps> {
	public static displayName = 'ProgramQuit';

	public renderText(hours: number, todos: number): string {
		const data = {
			hours,
			todos,
		};

		return hours < 1
			? i18n(`${labelBase}.text.lessThanOneHour`, data, todos)
			: i18n(`${labelBase}.text.default`, data, todos);
	}

	public handleClickFinish = () => {
		const { doRequestFinishManually } = this.props;
		doRequestFinishManually();
	};

	public render() {
		const { hours, todos, loading } = this.props;

		return (
			<div className="m-program-quit">
				<div className="container">
					<div className="row">
						<div className="col-sm-6 col-md-8">
							<h2 className="m-program-quit__title">{i18n(`${labelBase}.title`)}</h2>
							<div
								className="m-program-quit__text"
								dangerouslySetInnerHTML={{ __html: this.renderText(hours, todos) }}
							/>
						</div>
						<div className="col-sm-6 col-md-4">
							<div className="m-program-quit__button">
								<Link
									iconRight="link-arrow"
									modifier="button-green"
									title={i18n(`${labelBase}.buttonCaption`)}
									onClick={this.handleClickFinish}
									loading={loading}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
